export default {
  1: 'Scheduled',
  2: 'Ready To Start',
  3: 'Set 1 - In Progress',
  4: 'Set 1 - Finished',
  5: 'Set 2 - In Progress',
  6: 'Set 2 - Finished',
  7: 'Set 3 - In Progress',
  8: 'Set 3 - Finished',
  9: 'Set 4 - In Progress',
  10: 'Set 4 - Finished',
  11: 'Set 5 - In Progress',
  12: 'Finished',
  13: 'Official Result',
  14: 'Corrected',
  15: 'Closed',
}



// WEBPACK FOOTER //
// ./src/matchStatus.js